import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'

import { StaqRoutes } from '@staqjs/client'

import DemoPage from './DemoPage'

function App() {
  return (
    <Router>
      <StaqRoutes />

      <Route path="/demo" component={DemoPage} />
    </Router>
  )
}

export default App;
